import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$2629 August sidehustle report",
  "description": "",
  "published": "2017-09-08T00:00:00.000Z",
  "redirect_from": ["/blog/2629-august-sidehustle-report/swizec/7782"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "zG55Cz9mf_o",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Hmm ... $2629 ... that's not a very high number at all. Something's gone terribly wrong 🤔`}</p>
    <p>{`Oh yeah, I got so busy launching `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React+D3v4`}</a>{` that I didn't publish anything on `}<a parentName="p" {...{
        "href": "http://reactnative.school"
      }}>{`React Native School`}</a>{`. That revenue is based on articles published, no articles published, no revenue. Oops. 😇`}</p>
    <p>{`It's all good though, the sidehustle revenue for September is going to look spectacular. I'm excited already!`}</p>
    <p>{`A smart business man once said to me: Money does not exist until it becomes cash in bank.`}</p>
    <p>{`It's not your money until it's your money. Anything could happen. Oh you got a contract for a bunch of cash? Might get cancelled. Oh you did a bunch of work for someone? Maybe they'll go bust. Someone already wired you the cash but it hasn't arrived yet? Your bank might reject it.`}</p>
    <p>{`That's happened to me before. Client wired me money, mis-spelled my name, bank rejected the transfer. 💩`}</p>
    <p>{`In short: Yes, I launched React+D3v4 on August 16. Yes it made sales. No, it didn't hit my account until September.`}</p>
    <p>{`Gumroad makes payouts on Friday the week after. Revenue for the week of August 26th is hitting my account on Friday, September 8th. Last Friday was already September so React+D3v4 had no effect on August revenue.`}</p>
    <p>{`This scheduling quirk made my graph of monthly revenue look sad. The trend line in particular is cause for worry. 😕`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/09/Screen-Shot-2017-09-08-at-00.18.33.png",
        "alt": null
      }}></img></p>
    <p>{`Here's August in numbers 👇`}</p>
    <p><strong parentName="p">{`Total Revenue:`}</strong>{` $2629`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $1317`}</p>
    <ul>
      <li parentName="ul">{`React+D3v4 preorder: $685`}</li>
      <li parentName="ul">{`React+D3 ES6: $472`}</li>
      <li parentName="ul">{`ES6 cheatsheet: $19`}</li>
    </ul>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $312`}</p>
    <ul>
      <li parentName="ul">{`Why programmers work at night: $47`}</li>
      <li parentName="ul">{`React+D3: $33`}</li>
      <li parentName="ul">{`React+D3v4: $231`}</li>
    </ul>
    <p><strong parentName="p">{`React/JavaScript coaching:`}</strong>{` $1000`}</p>
    <p><strong parentName="p">{`LiveEdu premium:`}</strong>{` $4`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 66 hours`}</p>
    <p><strong parentName="p">{`Expenses:`}</strong>{` $1812 - Editor: $500 - VA: $400 - FB Ads: $176 - PonyFoo sponsorship: $250 - Domains: $131 - Dreamhost: $33 - AWS: $14 - now.sh: $15 - Webfaction: $10 - Drip: $184 - SumoMe: $99`}</p>
    <p>{`Why the fuck did I buy $131 worth of domains? What did I even buy O.o And I need to shut down Dreamhost and Mailchimp. Legacy stuff that I'm not using anymore lol.`}</p>
    <p><strong parentName="p">{`Hourly rate after expenses:`}</strong>{` $12`}</p>
    <p>{`That's $2 under minimum wage. Aaaaaalmost!`}</p>
    <p>{`I have high hopes for September 🤞`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      